/**
 * PostHog Configuration
 */

import { PosthogConfig } from './types';

export const getPosthogConfig = (): PosthogConfig => {
  const apiKey = process.env.REACT_APP_POSTHOG_KEY || '';
  const apiHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
  const disabled = process.env.REACT_APP_POSTHOG_DISABLE_TRACKING === 'true';
  const debug = process.env.REACT_APP_POSTHOG_DEBUG === 'true';

  return {
    apiKey,
    apiHost,
    disabled,
    debug,
  };
};

export const isPosthogEnabled = (): boolean => {
  const config = getPosthogConfig();
  return !config.disabled && !!config.apiKey;
};